export function base64ToFile(base64String: string, fileName: string) {
  const array = base64String.split(',')
  const mime = array[0]?.match(/:(.*?);/)?.[1]
  const bstr = atob(array?.[1] || '')
  let n = bstr.length
  const u8array = new Uint8Array(n)

  while (n--) {
    u8array[n] = bstr.charCodeAt(n)
  }

  return new File([u8array], fileName, { type: mime })
}
